import { MessageDescriptor } from 'react-intl';
import {
    HUB_MENU_LINK_TYPE_NAME_TEXT,
    HUB_MENU_LINK_TYPE_DESCRIPTION_TEXT,
} from '../../../../../event-hubs.text';

export enum MenuItemType {
    LINK = 'LINK',
    CUSTOM = 'CUSTOM',
}

export type MenuItemTypeOption = {
    type: MenuItemType;
    nameText: MessageDescriptor;
    descriptionText: MessageDescriptor;
};

export const MENU_ITEM_TYPE_DISPLAY_NAMES: Record<MenuItemType, string> = {
    [MenuItemType.LINK]: 'Link',
    [MenuItemType.CUSTOM]: 'Page',
};

export const MENU_ITEM_TYPE_OPTIONS: MenuItemTypeOption[] = [
    {
        type: MenuItemType.LINK,
        nameText: HUB_MENU_LINK_TYPE_NAME_TEXT,
        descriptionText: HUB_MENU_LINK_TYPE_DESCRIPTION_TEXT,
    },
];

export const POPOVER_WIDTH = 260;
export const POPOVER_GAP = 8;
